

// import axios from 'axios';
// import React, { useState, useEffect } from 'react';
// import { useParams, useLocation } from 'react-router-dom';

// const ParticipantArena = () => {
//   const { roomPin } = useParams(); 
//   const location = useLocation();

//   // State Management Matrix Tokens
//   const [pin, setPin] = useState(roomPin || '');
//   const [gamePin, setGamePin] = useState(roomPin || ''); 
//   const [joinStep, setJoinStep] = useState(roomPin ? 2 : 1); 
//   const [activeEventId, setActiveEventId] = useState(null);
//   const [hostUserId, setHostUserId] = useState(null); // Keeps track of target host mapping
//   const [participantId, setParticipantId] = useState(null); // Database ID returned from quiz_results table
//   const [isRegistered, setIsRegistered] = useState(false);
//   const [playerInfo, setPlayerInfo] = useState({ name: '', email: '', mobile: '' });
//   const [quizQuestions, setQuizQuestions] = useState([]);

//   const colors = {
//     blue: '#2f3194',
//     orange: '#f35018',
//     textMain: '#0f1137'
//   };

//   // Synchronize incoming URL parameters or navigate payloads
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const urlPin = params.get('pin');
//     const eventId = params.get('eventId');

//     if (urlPin) {
//       setPin(urlPin);
//       setGamePin(urlPin);
//       setJoinStep(2); 
//     }

//     if (eventId) {
//       setActiveEventId(eventId);
//     }

//     if (location.state?.name) {
//       setPlayerInfo(location.state);
//       setParticipantId(location.state.participantId || null);
//       setIsRegistered(true);
//     }
//   }, [location]);

//   // Fetch target quiz questions block when authenticated successfully
//   useEffect(() => {
//     if (isRegistered && activeEventId) {
//       // Fetch operational quiz sequence rows mapped to this specific eventId
//       axios.get(`https://rvapi.emedha.in/pages/api/api/questions?eventId=${activeEventId}`)
//         .then((response) => {
//           setQuizQuestions(response.data);
//         })
//         .catch((error) => console.error('Error loading quiz setup matrix rows:', error));
//     }
//   }, [isRegistered, activeEventId]);

//   // PIN validation handler hitting the volatile active rooms table lookup
//   const handleVerifyPinInput = async (e) => {
//     e.preventDefault();
    
//     if (gamePin.length !== 6) {
//       alert("Please enter a 6-digit numerical structure.");
//       return;
//     }

//     try {
//       const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${gamePin}`);
      
//       if (response.data.valid) {
//         setPin(gamePin);
//         setActiveEventId(response.data.eventId);
//         setHostUserId(response.data.userId); // Stores the host user_id parameter tracking context
//         setJoinStep(2); 
//       }
//     } catch (error) {
//       console.error("Verification error:", error);
//       alert(error.response?.data?.message || "Invalid Game PIN. Please check the host monitor.");
//     }
//   };

//   // Profile submission handler logging participant into permanent quiz_results database
//   const handleRegistrationSubmit = async (e) => {
//     e.preventDefault();

//     if (!playerInfo.name || !playerInfo.email || !playerInfo.mobile) {
//       alert("Please fill in all active identification fields.");
//       return;
//     }

//     try {
//       // POST structural payload data array to populate permanent tracking sheet entries
//       const response = await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/register-participant', {
//         name: playerInfo.name,
//         email: playerInfo.email,
//         mobile: playerInfo.mobile,
//         userId: hostUserId , // Fallback to a baseline master profile target if missing
//         eventId: activeEventId,
//           roomPin: gamePin // Pass the active room pin state value here!
//       });

//       if (response.data.success) {
//         setParticipantId(response.data.participantId); // Retain structural row instance index key reference
//         setIsRegistered(true);
//       }
//     } catch (error) {
//       console.error("Participant registration backend failure:", error);
//       alert("Failed to submit profile metrics into leaderboard records. Please try again.");
//     }
//   };

//   return (
//     <div className="participant-container" style={{ padding: '20px', fontFamily: '"Poppins", sans-serif' }}>
//       {!isRegistered ? (
//         <div>
//           {/* STEP 1: Enter & Verify 6-Digit PIN */}
//           {joinStep === 1 && (
//             <form onSubmit={handleVerifyPinInput} style={{ maxWidth: '400px', margin: '40px auto', padding: '20px', border: '1px solid #eee', borderRadius: '12px', background: '#fff' }}>
//               <h4 className="fw-bold mb-3" style={{ color: colors.blue }}>Enter Game PIN</h4>
//               <input 
//                 type="text" 
//                 maxLength={6}
//                 className="form-control text-center mb-3"
//                 style={{ fontSize: '24px', letterSpacing: '4px', fontWeight: 'bold' }}
//                 placeholder="000000" 
//                 required 
//                 value={gamePin}
//                 onChange={(e) => setGamePin(e.target.value.replace(/\D/g, ''))} 
//               />
//               <button type="submit" className="btn w-100 text-white" style={{ backgroundColor: colors.blue }}>Verify Access Code</button>
//             </form>
//           )}

//           {/* STEP 2: Complete Player Registration Profile */}
//           {joinStep === 2 && (
//             <form onSubmit={handleRegistrationSubmit} style={{ maxWidth: '400px', margin: '40px auto', padding: '20px', border: '1px solid #eee', borderRadius: '12px', background: '#fff' }}>
//               <h4 className="fw-bold mb-1" style={{ color: colors.blue }}>Complete Profile</h4>
//               <p className="small mb-3">Room Connected: <strong style={{ color: colors.orange }}>{gamePin}</strong></p>
              
//               <div className="mb-2">
//                 <input type="text" className="form-control" placeholder="Name" required value={playerInfo.name} onChange={(e) => setPlayerInfo({...playerInfo, name: e.target.value})} />
//               </div>
//               <div className="mb-2">
//                 <input type="email" className="form-control" placeholder="Email" required value={playerInfo.email} onChange={(e) => setPlayerInfo({...playerInfo, email: e.target.value})} />
//               </div>
//               <div className="mb-3">
//                 <input type="tel" className="form-control" placeholder="Mobile" required value={playerInfo.mobile} onChange={(e) => setPlayerInfo({...playerInfo, mobile: e.target.value})} />
//               </div>
              
//               <div className="d-flex gap-2">
//                 {!roomPin && (
//                   <button type="button" className="btn btn-light" onClick={() => setJoinStep(1)}>Back</button>
//                 )}
//                 <button type="submit" className="btn flex-grow-1 text-white" style={{ backgroundColor: colors.orange }}>Enter Arena 🚀</button>
//               </div>
//             </form>
//           )}
//         </div>
//       ) : (
//         /* STEP 3: Active Live Quiz Screen Layout */
//         <div className="quiz-screen-layout" style={{ textAlign: 'center', marginTop: '40px' }}>
//           <h2 className="fw-bold" style={{ color: colors.blue }}>Get Ready to Play!</h2>
//           <p className="text-muted">Connected to Event Target Room ID: {activeEventId}</p>
//           <p className="text-muted">Participant Tracker Log Reference Row Index: {participantId}</p>
          
//           {/* Live question viewer rows populate inside this layer matrix block wrapper */}
//           <div className="mt-4 text-start mx-auto" style={{ maxWidth: '600px' }}>
//             <span className="badge bg-success mb-2">Questions Loaded: {quizQuestions.length}</span>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ParticipantArena;


// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import axios from 'axios';

// const ParticipantArena = () => {
//   const location = useLocation();
//   const { pin: statePin, participantId } = location.state || {};
  
//   const params = new URLSearchParams(location.search);
//   const urlPin = params.get('pin');
//   const targetPin = statePin || urlPin || '';

//   const [gameState, setGameState] = useState(null);
//   const [questions, setQuestions] = useState([]);
//   const [hasAnswered, setHasAnswered] = useState(false);
//   const [isCorrectSelection, setIsCorrectSelection] = useState(false);
//   const [scoreFeedback, setScoreFeedback] = useState(0);
//   const [hostUserId, setHostUserId] = useState(null);
//   const premiumColors = ['#e21b3c', '#1368ce', '#d89e00', '#26890c'];
//   const shapes = ['▲', '◆', '●', '■'];

//   useEffect(() => {
//     if (!targetPin) return;

//     const syncConsumer = async () => {
//       try {
//         const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/game-state/${targetPin}`);
        
//         setGameState(prev => {
//           if (prev && prev.current_question_index !== response.data.current_question_index) {
//             return {
//               ...response.data,
//               resetAnswerLock: true 
//             };
//           }
//           return response.data;
//         });

//         // FIXED: Explicitly support snake_case extraction matching your MySQL table keys
//         let activeEventId = response.data.event_id || response.data.eventId;
        
//         if (!activeEventId) {
//           const verifyRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${targetPin}`);
//           if (verifyRes.data.valid) {
//             activeEventId = verifyRes.data.eventId || verifyRes.data.event_id;
//              setHostUserId(response.data.userId);

//           }
//         }

//         if (activeEventId && questions.length === 0) {
//           // FIXED: Pass BOTH query style parameter structures to clear up route matching definitions
//           const qRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/questions?eventId=${activeEventId}&event_id=${activeEventId}`);
//           if (Array.isArray(qRes.data)) {
//             setQuestions(qRes.data);
//           }
//         }
//       } catch (err) {
//         console.error("Participant arena state sync breakdown:", err);
//       }
//     };

//     syncConsumer();
//     const interval = setInterval(syncConsumer, 1000); 
//     return () => clearInterval(interval);
//   }, [targetPin, questions.length]);

//   useEffect(() => {
//     if (gameState && gameState.resetAnswerLock) {
//       setHasAnswered(false);
//       setIsCorrectSelection(false);
//       setScoreFeedback(0);
//       setGameState(prev => ({ ...prev, resetAnswerLock: false }));
//     }
//   }, [gameState]);

//   const handleSelectionSubmit = async (selectedOption) => {
//     if (hasAnswered) return;

//     const currentQuestion = gameState?.active_question || questions[gameState?.current_question_index];
//     if (!currentQuestion) return;

//     // Support flexible property checking keys from column rows (correct_answer vs correct)
//     const correctAnswer = currentQuestion.correct_answer || currentQuestion.correct;
//     const checkCorrect = selectedOption === correctAnswer;
    
//     const secondsLeft = gameState.seconds_left > 0 ? gameState.seconds_left : 15;
//     const basePoints = checkCorrect ? 500 : 0;
//     const speedBonus = checkCorrect ? Math.round(secondsLeft * 15) : 0;
//     const computedTotal = basePoints + speedBonus;

//     setHasAnswered(true);
//     setIsCorrectSelection(checkCorrect);
//     setScoreFeedback(computedTotal);

//     try {
//       await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/submit-answer', {
//         participantId: participantId,
//         isCorrect: checkCorrect,
//         pointsAwarded: computedTotal
//       });
//     } catch (err) {
//       console.error("Failed to post choice calculation scores:", err);
//     }
//   };

//   if (!gameState) {
//     return (
//       <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', background: '#0b0c26', color: '#6c757d', fontFamily: 'Poppins' }}>
//         <div className="text-center">
//           <div className="spinner-border text-info mb-3" role="status"></div>
//           <p className="d-block fw-semibold">Connecting to Live Game State...</p>
//         </div>
//       </div>
//     );
//   }

//   const currentQuestion = gameState.active_question || questions[gameState.current_question_index];

//   return (
//     <div style={{ background: '#0b0c26', minHeight: '100vh', color: '#fff', padding: '20px', fontFamily: 'Poppins' }}>
      
//       {/* 1. LOBBY STAGE DISPLAY PANEL */}
//       {gameState.game_stage === 'lobby' && (
//         <div className="text-center py-5" style={{ marginTop: '15%' }}>
//           <div style={{ fontSize: '64px', marginBottom: '20px' }}>🕹️</div>
//           <h2 className="fw-bold">You are linked smoothly!</h2>
//           <p style={{ color:"#fff" }} className="fs-5">Room Session Active: <strong style={{ color: '#63decc' }}>{targetPin}</strong></p>
//           <p style={{ color:"#fff" }} className="small">Look at the main host display monitor. The match will begin shortly...</p>
//         </div>
//       )}

//       {/* 2. ACTIVE QUESTION CONTAINER PANEL */}
//       {gameState.game_stage === 'question' && (
//         <div>
//           <div className="d-flex justify-content-between align-items-center mb-4 px-2">
//             <span className="fw-bold" style={{ color: '#63decc' }}>
//               Question {gameState.current_question_index + 1} {gameState.total_questions_count ? `of ${gameState.total_questions_count}` : ''}
//             </span>
//             <span className="badge bg-warning px-3 py-2 fs-6" style={{ borderRadius: '20px' }}>
//               ⏱️ {gameState.seconds_left > 0 ? gameState.seconds_left : 0}s
//             </span>
//           </div>

//           {currentQuestion && !hasAnswered ? (
//             <div>
//               {/* Question Text Frame wrapper */}
//               <div className="bg-white text-dark p-3 rounded-3 text-center mb-4 shadow">
//                 <h5 className="fw-bold m-0" style={{ fontSize: '16px', lineHeight: '1.4' }}>{currentQuestion.question}</h5>
//               </div>

//               {/* Grid Layout Row Triggers */}
//               <div className="row g-3">
//                 {[currentQuestion.option_1, currentQuestion.option_2, currentQuestion.option_3, currentQuestion.option_4].map((opt, idx) => {
//                   if (!opt && idx >= 2) return null; 
//                   const optionText = opt || `Choice Option ${idx + 1}`;

//                   return (
//                     <div key={idx} className="col-6">
//                       <button 
//                         onClick={() => handleSelectionSubmit(optionText)}
//                         className="w-100 border-0 text-white fw-bold shadow-lg d-flex flex-column align-items-center justify-content-center px-2"
//                         style={{ background: premiumColors[idx], height: '140px', borderRadius: '16px', position: 'relative' }}
//                       >
//                         <span style={{ fontSize: '24px', marginBottom: '4px', opacity: 0.8 }}>{shapes[idx]}</span>
//                         <span style={{ fontSize: '15px', lineHeight: '1.2' }}>{optionText}</span>
//                       </button>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           ) : (
//             /* Secure fallback state logging message display block */
//             <div className="text-center py-5 mt-5" style={{ background: 'rgba(255,255,255,0.02)', borderRadius: '24px', border: '1px solid rgba(255,255,255,0.05)' }}>
//               <div style={{ fontSize: '56px', marginBottom: '15px' }}>🚀</div>
//               <h4 className="fw-bold">Answer Logged Safely</h4>
//               <p style={{ color:"#fff" }} className="small px-4">Waiting for the answer confirmation frame update from the host monitor...</p>
//             </div>
//           )}
//         </div>
//       )}

//       {/* 3. REVEAL ANSWERS STAGE DISPLAY PANEL */}
//       {gameState.game_stage === 'reveal' && (
//         <div className="text-center py-5 mt-5" style={{ borderRadius: '24px', background: isCorrectSelection ? 'rgba(38, 137, 12, 0.12)' : 'rgba(226, 27, 60, 0.12)', border: `1px solid ${isCorrectSelection ? '#26890c' : '#e21b3c'}` }}>
//           <div style={{ fontSize: '72px' }}>{isCorrectSelection ? '✅' : '❌'}</div>
//           <h2 className="fw-bold mt-2" style={{ color: isCorrectSelection ? '#26890c' : '#e21b3c' }}>{isCorrectSelection ? 'Correct' : 'Incorrect'}</h2>
//           <h1 className="fw-extrabold mt-3" style={{ fontSize: '48px', color: '#63decc' }}>+{scoreFeedback} pts</h1>
//         </div>
//       )}

//       {/* 4. FINAL RESULTS CHAMPIONSHIP PODIUM DISPLAY PANEL */}
//       {gameState.game_stage === 'podium' && (
//         <div className="text-center py-5" style={{ marginTop: '15%' }}>
//           <div style={{ fontSize: '64px', marginBottom: '20px' }}>🏁</div>
//           <h2 className="fw-bold">Match Completed!</h2>
//           <p className="fs-6 px-3">Check the primary host leaderboard monitor to view your final position ranking status.</p>
//         </div>
//       )}

//     </div>
//   );
// };

// export default ParticipantArena;


import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import axios from 'axios';

const ParticipantArena = () => {
  const { roomPin } = useParams(); 
  const location = useLocation();
  
  const { pin: statePin, participantId: stateParticipantId } = location.state || {};
  
  // Parse parameters across dynamic routing variants or QR code link query streams
  const params = new URLSearchParams(location.search);
  const urlPin = params.get('pin');
  const urlEventId = params.get('eventId');
  const initialPin = statePin || urlPin || roomPin || '';
const [activeEventId, setActiveEventId] = useState(urlEventId || null);
  // --- STEP & REGISTRATION STATES ---
  const [gamePin, setGamePin] = useState(initialPin);
  const [targetPin, setTargetPin] = useState(initialPin);
  const [joinStep, setJoinStep] = useState(initialPin ? 2 : 1); 
  const [isRegistered, setIsRegistered] = useState(false);
  const [participantId, setParticipantId] = useState(stateParticipantId || null);
  const [playerInfo, setPlayerInfo] = useState({ name: '', email: '', mobile: '' });

  // --- LIVE QUIZ GAME LOOP STATES ---
  const [gameState, setGameState] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [hasAnswered, setHasAnswered] = useState(false);
  const [isCorrectSelection, setIsCorrectSelection] = useState(false);
  const [scoreFeedback, setScoreFeedback] = useState(0);
  const [hostUserId, setHostUserId] = useState(null);
  const [pin, setPin] = useState(roomPin || '');


  // --- RETURNING USER & MOBILE CHECK STATE ---
  const [mobileNumber, setMobileNumber] = useState('');
  const [isVerifyingPlayer, setIsVerifyingPlayer] = useState(false);
  const [sessionInfo, setSessionInfo] = useState(null);



// --- TAB TOGGLE STATE ---
  const [regTab, setRegTab] = useState('new'); // 'new' | 'returning'
  const [loginMobile, setLoginMobile] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);
const [maxAllowedPlayers, setMaxAllowedPlayers] = useState(100);

  const premiumColors = ['#e21b3c', '#1368ce', '#d89e00', '#26890c'];
  const shapes = ['▲', '◆', '●', '■'];
  // Operational state for player's final performance scorecard metrics
  const [personalStats, setPersonalStats] = useState(null);

  // Handle components landing directly from pre-registered view states
  // useEffect(() => {
  //   const paramsCheck = new URLSearchParams(location.search);
  //   const queryPin = paramsCheck.get('pin');
    
  //   if (queryPin) {
  //     setPinData(queryPin);
  //   }

  //   if (location.state?.name) {
  //     setPlayerInfo(location.state);
  //     setParticipantId(location.state.participantId || null);
  //     setIsRegistered(true);
  //   }
  // }, [location]);


  // Handle components landing directly from URL parameters or QR code links
  useEffect(() => {
    const paramsCheck = new URLSearchParams(location.search);
    const queryPin = paramsCheck.get('pin') || roomPin || statePin;
    
    if (queryPin) {
      setPinData(queryPin);

      // Immediately fetch room quota & capacity for direct-link entries
      axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${queryPin}`)
        .then(res => {
          if (res.data?.valid) {
            setHostUserId(res.data.userId);
            setActiveEventId(res.data.eventId);
            setSessionInfo(res.data);
            if (res.data.maxParticipants !== undefined) {
              console.log("[ParticipantArena] Direct-link maxParticipants:", res.data.maxParticipants);
              setMaxAllowedPlayers(Number(res.data.maxParticipants));
            }
          }
        })
        .catch(err => console.error("[ParticipantArena] verify-pin link error:", err));
    }

    if (location.state?.name) {
      setPlayerInfo(location.state);
      setParticipantId(location.state.participantId || null);
      setIsRegistered(true);
    }
  }, [location, roomPin, statePin]);





  //check it

  useEffect(() => {
    if (gameState?.game_stage === 'question') {
      setHasAnswered(false);
      setIsCorrectSelection(false);
      setScoreFeedback(0);
    }
  }, [gameState?.current_question_index, gameState?.game_stage]);

  const setPinData = (pinValue) => {
    setPin(pinValue);
    setGamePin(pinValue);
    setTargetPin(pinValue);
    setJoinStep(2);
  };

  // ACTIVE LIVE REAL-TIME REFRESH MONITOR CONSUMER
  // useEffect(() => {
  //   if (!isRegistered || !targetPin) return;

  //   const syncConsumer = async () => {
  //     try {
  //       const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/game-state/${targetPin}`);
        
  //       setGameState(prev => {
  //         if (prev && prev.current_question_index !== response.data.current_question_index) {
  //           return {
  //             ...response.data,
  //             resetAnswerLock: true 
  //           };
  //         }
  //         return response.data;
  //       });

  //  let currentEventId = response.data.event_id || response.data.eventId || urlEventId;
        
  //       if (currentEventId && !activeEventId) {
  //         setActiveEventId(currentEventId);
  //       }

  //       // Fetch host contextual attributes if missing from state models
  //       if (!currentEventId || !hostUserId) {
  //         const verifyRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${targetPin}`);
  //         if (verifyRes.data.valid) {
  //           currentEventId = verifyRes.data.eventId || verifyRes.data.event_id;
  //           setActiveEventId(currentEventId);
  //           setHostUserId(verifyRes.data.userId);
  //         }
  //       }

  //       if (activeEventId && questions.length === 0) {
  //         const qRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/questions?eventId=${activeEventId}&event_id=${activeEventId}`);
  //         if (Array.isArray(qRes.data)) {
  //           setQuestions(qRes.data);
  //         }
  //       }
  //     } catch (err) {
  //       console.error("Participant arena state sync breakdown:", err);
  //     }
  //   };

  //   syncConsumer();
  //   const interval = setInterval(syncConsumer, 1000); 
  //   return () => clearInterval(interval);
  // }, [isRegistered, targetPin, questions.length, hostUserId, urlEventId]);

  // ACTIVE LIVE REAL-TIME REFRESH MONITOR CONSUMER
  // useEffect(() => {
  //   if (!isRegistered || !targetPin) return;

  //   const syncConsumer = async () => {
  //     try {
  //       const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/game-state/${targetPin}`);
        
  //       setGameState(prev => {
  //         if (prev && prev.current_question_index !== response.data.current_question_index) {
  //           return {
  //             ...response.data,
  //             resetAnswerLock: true 
  //           };
  //         }
  //         return response.data;
  //       });

  //       // 1. If game reaches podium, fetch personal performance metrics if not loaded yet
  //       if (response.data.game_stage === 'podium' && !personalStats && participantId) {
  //         try {
  //           const statsRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/participant-stats/${targetPin}/${participantId}`);
  //           setPersonalStats(statsRes.data);
  //         } catch (statsErr) {
  //           console.error("Failed to load personal podium statistics:", statsErr);
  //         }
  //       }

  //       let activeEventId = response.data.event_id || response.data.eventId || urlEventId;
        
  //       if (activeEventId && !activeEventId) {
  //         setActiveEventId(activeEventId);
  //       }

  //       if (!activeEventId || !hostUserId) {
  //         const verifyRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${targetPin}`);
  //         if (verifyRes.data.valid) {
  //           activeEventId = verifyRes.data.eventId || verifyRes.data.event_id;
  //           setActiveEventId(activeEventId);
  //           setHostUserId(verifyRes.data.userId);
  //         }
  //       }

  //       if (activeEventId && questions.length === 0) {
  //         const qRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/questions?eventId=${activeEventId}&event_id=${activeEventId}`);
  //         if (Array.isArray(qRes.data)) {
  //           setQuestions(qRes.data);
  //         }
  //       }


  //       if (response.data.game_stage === 'podium') {
  //   // Clear session so future games start clean
  //   localStorage.removeItem(`quiz_session_${targetPin}`);
    
  //   if (!personalStats && participantId) {
  //     try {
  //       const statsRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/participant-stats/${targetPin}/${participantId}`);
  //       setPersonalStats(statsRes.data);
  //     } catch (statsErr) {
  //       console.error("Failed to load personal podium statistics:", statsErr);
  //     }
  //   }
  // }


  //     } catch (err) {
  //       console.error("Participant arena state sync breakdown:", err);
  //     }
  //   };

  //   syncConsumer();
  //   const interval = setInterval(syncConsumer, 1000); 
  //   return () => clearInterval(interval);
  // }, [isRegistered, targetPin, questions.length, hostUserId, urlEventId, personalStats, participantId]);


const API_BASE = 'https://rvapi.emedha.in';

  // ACTIVE LIVE REAL-TIME REFRESH MONITOR CONSUMER
  useEffect(() => {
    if (!isRegistered || !targetPin) return;

    const syncConsumer = async () => {
      try {
        const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/game-state/${targetPin}`);
        
        setGameState(prev => {
          if (prev && prev.current_question_index !== response.data.current_question_index) {
            return {
              ...response.data,
              resetAnswerLock: true 
            };
          }
          return response.data;
        });

        // 1. If game reaches podium, fetch personal performance metrics
        if (response.data.game_stage === 'podium') {
          localStorage.removeItem(`quiz_session_${targetPin}`);
          
          if (!personalStats && participantId) {
            try {
              const statsRes = await axios.get(`${API_BASE}/pages/api/api/quiz/participant-stats/${targetPin}/${participantId}`);
              setPersonalStats(statsRes.data);
            } catch (statsErr) {
              console.error("Failed to load personal podium statistics:", statsErr);
            }
          }
        }

        // 2. Resolve eventId & questions if not already fetched
        let resolvedEventId = response.data.event_id || response.data.eventId || activeEventId || urlEventId;

        if (!resolvedEventId || !hostUserId) {
          const verifyRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${targetPin}`);
          if (verifyRes.data.valid) {
            resolvedEventId = verifyRes.data.eventId;
            setActiveEventId(resolvedEventId);
            setHostUserId(verifyRes.data.userId);
            setSessionInfo(verifyRes.data);
             if (verifyRes.data.maxParticipants !== undefined) {
        setMaxAllowedPlayers(verifyRes.data.maxParticipants);
      }
          }

            
        }

        if (resolvedEventId && questions.length === 0) {
          const qRes = await axios.get(`${API_BASE}/pages/api/api/questions?eventId=${resolvedEventId}`);
          if (Array.isArray(qRes.data)) {
            setQuestions(qRes.data);
          }
        }

      } catch (err) {
        console.error("Participant arena sync error:", err);
      }
    };

    syncConsumer();
    const interval = setInterval(syncConsumer, 2000); 
    return () => clearInterval(interval);
  }, [isRegistered, targetPin, questions.length, hostUserId, urlEventId, personalStats, participantId, activeEventId]);


  useEffect(() => {
    if (gameState && gameState.resetAnswerLock) {
      setHasAnswered(false);
      setIsCorrectSelection(false);
      setScoreFeedback(0);
      setGameState(prev => ({ ...prev, resetAnswerLock: false }));
    }
  }, [gameState]);

  // STEP 1: Process PIN Validation Check manual submissions
  // const handleVerifyPinInput = async (e) => {
  //   e.preventDefault();
    
  //   if (gamePin.length !== 6) {
  //     alert("Please enter a 6-digit numerical structure.");
  //     return;
  //   }

  //   try {
  //     const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${gamePin}`);
      
  //     if (response.data.valid) {
  //       setTargetPin(gamePin);
  //       setHostUserId(response.data.userId);
  //       setJoinStep(2); 
  //     }
  //   } catch (error) {
  //     console.error("Verification error:", error);
  //     alert(error.response?.data?.message || "Invalid Game PIN. Please check the host monitor.");
  //   }
  // };



  // Handler for "Already Registered" tab
  const handleReturningLogin = async (e) => {
    e.preventDefault();
    if (!loginMobile.trim()) {
      alert("Please enter your registered mobile number.");
      return;
    }

    try {
      setIsLoggingIn(true);
      const res = await axios.get(
        `${API_BASE}/pages/api/api/quiz/check-registered-player/${targetPin}/${loginMobile.trim()}`
      );

      if (res.data?.registered) {
        const player = res.data.player;
        setPlayerInfo({
          name: player.name,
          email: player.email,
          mobile: player.mobile,
        });
        setParticipantId(player.id);

        // Seed initial game state if waiting on polling
        setGameState(prev => prev || {
          game_stage: sessionInfo?.status === 'scheduled' ? 'scheduled' : 'lobby',
          scheduled_at: sessionInfo?.scheduledAt || null,
          current_question_index: 0,
          seconds_left: 0
        });

        setIsRegistered(true);
      } else {
        alert("No registration found with this mobile number for this room PIN. Please use the New Registration tab.");
        setRegTab('new');
        setPlayerInfo(prev => ({ ...prev, mobile: loginMobile.trim() }));
      }
    } catch (err) {
      console.error("Login verification failed:", err);
      alert(err.response?.data?.message || "Failed to verify registration. Please try again.");
    } finally {
      setIsLoggingIn(false);
    }
  };

  // STEP 1: Verify PIN & Check if Returning Player
  const handleVerifyPinInput = async (e) => {
    e.preventDefault();
    
    if (gamePin.length !== 6) {
      alert("Please enter a valid 6-digit PIN.");
      return;
    }

    try {
      setIsVerifyingPlayer(true);
      const pinRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${gamePin}`);
      
      if (pinRes.data.valid) {
        setTargetPin(gamePin);
        setHostUserId(pinRes.data.userId);
        setActiveEventId(pinRes.data.eventId);
        setSessionInfo(pinRes.data);


        if (pinRes.data.maxParticipants !== undefined) {
        setMaxAllowedPlayers(pinRes.data.maxParticipants);
      }

        // If user also provided mobile number, check if already registered
        if (mobileNumber.trim()) {
          const checkRes = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/check-registered-player/${gamePin}/${mobileNumber.trim()}`);
          if (checkRes.data?.registered) {
            const player = checkRes.data.player;
            setPlayerInfo({
              name: player.name,
              email: player.email,
              mobile: player.mobile,
            });
            setParticipantId(player.id);
            setIsRegistered(true);
            return;
          }
        }

        // Otherwise advance to fill out registration details
        setJoinStep(2);
      }
    } catch (error) {
      console.error("Verification error:", error);
      alert(error.response?.data?.message || "Invalid Game PIN or room has closed.");
    } finally {
      setIsVerifyingPlayer(false);
    }
  };

  // STEP 2: Process persistent participant registration row payload updates
  const handleRegistrationSubmit = async (e) => {
    e.preventDefault();

    if (!playerInfo.name || !playerInfo.email || !playerInfo.mobile) {
      alert("Please fill in all active identification fields.");
      return;
    }

    try {
      let currentEventId = urlEventId;
      let currentHostId = hostUserId;

      // Safe backup: If states weren't fully loaded by interval yet, pull them immediately right now
      if (!currentEventId || !currentHostId) {
        const stateCheck = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/game-state/${targetPin}`);
        currentEventId = stateCheck.data.event_id || stateCheck.data.eventId || urlEventId;
        currentHostId = currentHostId || stateCheck.data.user_id || stateCheck.data.userId;
      }

      // If still not resolved, query verify-pin fallback endpoint
      if (!currentEventId || !currentHostId) {
        const verifyCheck = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz/verify-pin/${targetPin}`);
        if (verifyCheck.data.valid) {
          currentEventId = verifyCheck.data.eventId;
          currentHostId = verifyCheck.data.userId;
           if (verifyCheck.data.maxParticipants !== undefined) {
        setMaxAllowedPlayers(verifyCheck.data.maxParticipants);
      }
        }
        
       

      }

      const response = await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/register-participant', {
        name: playerInfo.name,
        email: playerInfo.email,
        mobile: playerInfo.mobile,
        userId: currentHostId, 
        eventId: currentEventId,
        roomPin: targetPin 
      });

      if (response.data.success) {
        setParticipantId(response.data.participantId); 
      
        setIsRegistered(true); 
        // localStorage.setItem(`quiz_session_${targetPin}`, JSON.stringify({
        //   participantId: response.data.participantId,
        //   playerInfo
        // }));

      }
    } catch (error) {
      console.error("Participant registration backend failure:", error);
      const errorMsg = error.response?.data?.error || "Failed to submit profile details. Please try again.";
      alert(errorMsg);
 
    }
  };

  // const handleSelectionSubmit = async (selectedOption) => {
  //   if (hasAnswered) return;

  //   const currentQuestion = gameState?.active_question || questions[gameState?.current_question_index];
  //   if (!currentQuestion) return;

  //   const correctAnswer = currentQuestion.correct_answer || currentQuestion.correct;
  //   const checkCorrect = selectedOption === correctAnswer;
    
  //   const secondsLeft = gameState.seconds_left > 0 ? gameState.seconds_left : 15;
  //   const basePoints = checkCorrect ? 500 : 0;
  //   const speedBonus = checkCorrect ? Math.round(secondsLeft * 15) : 0;
  //   const computedTotal = basePoints + speedBonus;

  //   setHasAnswered(true);
  //   setIsCorrectSelection(checkCorrect);
  //   setScoreFeedback(computedTotal);

  //   try {
  //     await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/submit-answer', {
  //       participantId: participantId,
  //       isCorrect: checkCorrect,
  //       pointsAwarded: computedTotal
  //     });
  //   } catch (err) {
  //     console.error("Failed to post choice calculation scores:", err);
  //   }
  // };


// const handleSelectionSubmit = async (selectedOption) => {
//     if (hasAnswered || !gameState) return;

//     const currentQuestion = gameState.active_question || questions[gameState.current_question_index];
//     if (!currentQuestion) return;

//     const correctAnswer = currentQuestion.correct_answer || currentQuestion.correct;
//     const checkCorrect = selectedOption === correctAnswer;
    
//     // Fetch dynamic question marks configured by the host out of our live state payload
//     const basePoints = gameState.current_question_marks || 10;
//     const secondsLeft = gameState.seconds_left > 0 ? gameState.seconds_left : 0;
    
//     // Calculate local visual preview calculation feedback parameters matching backend rule curves
//     const speedBonus = checkCorrect ? Math.round(secondsLeft * 1.5) : 0;
//     const computedTotal = checkCorrect ? (basePoints + speedBonus) : 0;

//     setHasAnswered(true);
//     setIsCorrectSelection(checkCorrect);
//     setScoreFeedback(computedTotal);

//     try {
//       // Transmit the active state tracking markers to the computation endpoint engine layout
//       await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/submit-answer', {
//         participantId: participantId,
//         isCorrect: checkCorrect,
//         secondsLeft: secondsLeft,
//         roomPin: targetPin
//       });
//     } catch (err) {
//       console.error("Failed to post choice calculation scores payload matrix:", err);
//     }
//   };

const handleCheckReturningPlayer = async (inputPin, inputMobile) => {
  try {
    const res = await axios.get(
      `https://rvapi.emedha.in/pages/api/api/quiz/check-registered-player/${inputPin}/${inputMobile}`
    );

    if (res.data?.registered) {
      // 1. Found player: skip registration form!
      const player = res.data.player;
      setPlayerInfo({
        name: player.name,
        email: player.email,
        mobile: player.mobile,
      });
      setParticipantId(player.id);
      setIsRegistered(true); // Takes user straight to countdown or live quiz
    } else {
      // 2. Not registered: show full registration form (Name & Email fields)
      setJoinStep(2); 
    }
  } catch (err) {
    console.error("Check player registration error:", err);
    // Fallback: proceed to standard registration form
    setJoinStep(2);
  }
};

// const handleSelectionSubmit = async (selectedOption) => {
//     if (hasAnswered || !gameState) return;

//     const currentQuestion = gameState.active_question || questions[gameState.current_question_index];
//     if (!currentQuestion) return;

//     const correctAnswer = currentQuestion.correct_answer || currentQuestion.correct;
//     const checkCorrect = selectedOption === correctAnswer;
    
//     // Dynamic values from game state
//     const basePoints = gameState.current_question_marks || 10;
//     const secondsLeft = gameState.seconds_left > 0 ? gameState.seconds_left : 0;
    
//     // Calculate seconds taken by the player
//     const totalDurationAllowed = gameState.total_duration || 30; 
//     const secondsTaken = Math.max(0, totalDurationAllowed - secondsLeft);
    
//     // Calculate speed bonus curves
//     const speedBonus = checkCorrect ? Math.round(secondsLeft * 1.5) : 0;
//     const computedTotal = checkCorrect ? (basePoints + speedBonus) : 0;

//     setHasAnswered(true);
//     setIsCorrectSelection(checkCorrect);
//     setScoreFeedback(computedTotal);

//     // Securely derive operational parameters across all structural fallbacks
//     // If absolutely missing, fallback to 0 or currentQuestion's native column property to avoid null crash
//     const finalEventId = gameState.event_id || gameState.eventId || activeEventId || currentQuestion.event_id || 0;
//     const finalUserId = hostUserId || gameState.user_id || gameState.userId || currentQuestion.user_id || 18;

//     try {
//       // Transmit the rich data payload tracking log to the backend endpoint
//       await axios.post('https://rvapi.emedha.in/pages/api/api/quiz/submit-answer', {
//         participantId: participantId,
//         roomPin: targetPin,
//         eventId: finalEventId,
//         userId: finalUserId,
//         questionId: currentQuestion.id,
//         isCorrect: checkCorrect ? 1 : 0,
//         secondsLeft: secondsLeft,
//         secondsTaken: secondsTaken
//       });
//     } catch (err) {
//       console.error("Failed to post choice calculation scores payload matrix:", err);
//     }
//   };

const handleSelectionSubmit = async (selectedOption, selectedImage = null) => {
    if (hasAnswered || !gameState) return;

    const currentQuestion = gameState.active_question || (questions.length > 0 ? questions[gameState.current_question_index] : null);
    if (!currentQuestion) return;

    // 1. Check Correct Answer for both Text Quizzes and Image Quizzes
    const correctAnswer = currentQuestion.correct_answer || currentQuestion.correct;
    const correctImage = currentQuestion.correct_image;

    let checkCorrect = false;
    if (correctImage) {
  
      checkCorrect = (selectedImage === correctImage) || (selectedOption === correctImage);
    } else if (correctAnswer) {
   
      checkCorrect = (selectedOption === correctAnswer);
    }
    
    // Dynamic values from game state
    const basePoints = gameState.current_question_marks || 10;
    const secondsLeft = gameState.seconds_left > 0 ? gameState.seconds_left : 0;
    
    // Calculate seconds taken by the player
    const totalDurationAllowed = gameState.total_duration || 30; 
    const secondsTaken = Math.max(0, totalDurationAllowed - secondsLeft);
    
    // Calculate speed bonus curves
    const speedBonus = checkCorrect ? Math.round(secondsLeft * 1.5) : 0;
    const computedTotal = checkCorrect ? (basePoints + speedBonus) : 0;

    setHasAnswered(true);
    setIsCorrectSelection(checkCorrect);
    setScoreFeedback(computedTotal);

    const finalEventId = gameState.active_event_id || gameState.event_id || gameState.eventId || activeEventId || currentQuestion.event_id || 0;
    const finalUserId = hostUserId || gameState.user_id || gameState.userId || currentQuestion.user_id || 18;

    try {
      await axios.post(`${API_BASE}/pages/api/api/quiz/submit-answer`, {
        participantId: participantId,
        roomPin: targetPin,
        eventId: finalEventId,
        userId: finalUserId,
        questionId: currentQuestion.id,
        isCorrect: checkCorrect ? 1 : 0,
        secondsLeft: secondsLeft,
        secondsTaken: secondsTaken
      });
    } catch (err) {
      console.error("Failed to post choice calculation scores:", err);
    }
  };


// --- VIEW 1: REGISTRATION & PIN SCREEN ---
  if (!isRegistered) {
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', background: '#0b0c26', fontFamily: 'Poppins', padding: '20px' }}>
        <div style={{ maxWidth: '420px', width: '100%', background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', padding: '30px', borderRadius: '24px', backdropFilter: 'blur(12px)' }}>
          
   
      {/* STEP 1: CLEAN PIN INPUT SCREEN */}
          {joinStep === 1 && (
            <form onSubmit={handleVerifyPinInput} className="text-center">
              <div style={{ fontSize: '48px', marginBottom: '10px' }}>🕹️</div>
              <h4 className="fw-bold mb-2 text-white">Enter Game PIN</h4>
              <p className="small mb-3" style={{ color: '#cbd5e1' }}>Enter the 6-digit room PIN provided by the host</p>

              <input 
                type="text" 
                maxLength={6}
                className="form-control text-center mb-4 text-white"
                style={{ fontSize: '32px', letterSpacing: '6px', fontWeight: 'bold', background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(99,222,204,0.4)', borderRadius: '14px' }}
                placeholder="000000" 
                required 
                value={gamePin}
                onChange={(e) => setGamePin(e.target.value.replace(/\D/g, ''))} 
              />

              <button 
                type="submit" 
                disabled={isVerifyingPlayer}
                className="btn w-100 fw-bold py-3 text-white" 
                style={{ backgroundColor: '#2f3194', borderRadius: '12px', border: 'none' }}
              >
                {isVerifyingPlayer ? 'Connecting...' : 'Proceed to Room 🚀'}
              </button>
            </form>
          )}

          {/* STEP 2: Name, Email, Mobile Form */}
    {/* STEP 2: DUAL-TAB REGISTRATION & LOGIN SCREEN */}
          {joinStep === 2 && (
            <div>
              <div className="text-center mb-3">
                <h4 className="fw-bold text-white mb-1">Join Quiz Arena</h4>
               <span className="badge px-3 py-1.5 rounded-pill" style={{ backgroundColor: 'rgba(243,80,24,0.15)', color: '#f35018', border: '1px solid rgba(243,80,24,0.3)', fontSize: '11px' }}>
        Connected PIN: {targetPin} &bull; Capacity: {maxAllowedPlayers === -1 ? 'Unlimited' : `${maxAllowedPlayers} Max`}
      </span>
              </div>

              {/* TAB SELECTOR STRIP */}
              <div className="d-flex p-1 rounded-3 mb-4" style={{ backgroundColor: 'rgba(255, 255, 255, 0.08)', border: '1px solid rgba(255, 255, 255, 0.12)' }}>
                <button
                  type="button"
                  onClick={() => setRegTab('new')}
                  className="btn btn-sm w-50 fw-bold transition-all"
                  style={{
                    backgroundColor: regTab === 'new' ? '#f35018' : 'transparent',
                    color: '#ffffff',
                    borderRadius: '8px',
                    fontSize: '12px',
                    border: 'none',
                    padding: '8px 0'
                  }}
                >
                  ✨ New Registration
                </button>
                <button
                  type="button"
                  onClick={() => setRegTab('returning')}
                  className="btn btn-sm w-50 fw-bold transition-all"
                  style={{
                    backgroundColor: regTab === 'returning' ? '#2f3194' : 'transparent',
                    color: '#ffffff',
                    borderRadius: '8px',
                    fontSize: '12px',
                    border: 'none',
                    padding: '8px 0'
                  }}
                >
                  🔑 Already Registered
                </button>
              </div>

              {/* TAB 1: NEW REGISTRATION FORM */}
              {regTab === 'new' && (
                <form onSubmit={handleRegistrationSubmit}>
                  <div className="mb-3">
                    <label className="text-white small fw-semibold mb-1">Full Name *</label>
                    <input 
                      type="text" 
                      className="form-control px-3 py-2 text-dark bg-white" 
                      placeholder="Enter your name" 
                      required 
                      value={playerInfo.name} 
                      onChange={(e) => setPlayerInfo({...playerInfo, name: e.target.value})} 
                    />
                  </div>

                  <div className="mb-3">
                    <label className="text-white small fw-semibold mb-1">Email Address *</label>
                    <input 
                      type="email" 
                      className="form-control px-3 py-2 text-dark bg-white" 
                      placeholder="Enter your email" 
                      required 
                      value={playerInfo.email} 
                      onChange={(e) => setPlayerInfo({...playerInfo, email: e.target.value})} 
                    />
                  </div>

                  <div className="mb-4">
                    <label className="text-white small fw-semibold mb-1">Mobile Number *</label>
                    <input 
                      type="tel" 
                      className="form-control px-3 py-2 text-dark bg-white" 
                      placeholder="Enter 10-digit mobile number" 
                      required 
                      value={playerInfo.mobile} 
                      onChange={(e) => setPlayerInfo({...playerInfo, mobile: e.target.value})} 
                    />
                  </div>
                  
                  <div className="d-flex gap-2">
                    {!initialPin && (
                      <button type="button" className="btn btn-outline-light px-3" style={{ borderRadius: '12px' }} onClick={() => setJoinStep(1)}>
                        Back
                      </button>
                    )}
                    <button type="submit" className="btn flex-grow-1 text-white fw-bold py-2.5" style={{ backgroundColor: '#f35018', borderRadius: '12px', border: 'none' }}>
                      Register &amp; Enter 🚀
                    </button>
                  </div>
                </form>
              )}

              {/* TAB 2: ALREADY REGISTERED (MOBILE ONLY) FORM */}
              {regTab === 'returning' && (
                <form onSubmit={handleReturningLogin}>
                  <p className="small mb-3 text-center" style={{ color: '#cbd5e1' }}>
                    Enter the mobile number you used during pre-registration to jump right in.
                  </p>

                  <div className="mb-4">
                    <label className="text-white small fw-semibold mb-1">Registered Mobile Number *</label>
                    <input 
                      type="tel" 
                      className="form-control px-3 py-2.5 text-dark bg-white" 
                      placeholder="e.g. 9876543210" 
                      required 
                      value={loginMobile} 
                      onChange={(e) => setLoginMobile(e.target.value)} 
                    />
                  </div>

                  <div className="d-flex gap-2">
                    {!initialPin && (
                      <button type="button" className="btn btn-outline-light px-3" style={{ borderRadius: '12px' }} onClick={() => setJoinStep(1)}>
                        Back
                      </button>
                    )}
                    <button 
                      type="submit" 
                      disabled={isLoggingIn}
                      className="btn flex-grow-1 text-white fw-bold py-2.5" 
                      style={{ backgroundColor: '#2f3194', borderRadius: '12px', border: 'none' }}
                    >
                      {isLoggingIn ? 'Verifying...' : 'Verify & Enter Arena 🎮'}
                    </button>
                  </div>
                </form>
              )}

            </div>
          )}

        </div>
      </div>
    );
  }

  // --- VIEW 2: LOADING STATE BUFFER ---
  if (!gameState) {
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', background: '#0b0c26', color: '#6c757d', fontFamily: 'Poppins' }}>
        <div className="text-center">
          <div className="spinner-border text-info mb-3" role="status"></div>
          <p className="d-block fw-semibold">Connecting to Live Game State...</p>
        </div>
      </div>
    );
  }


    //check it

    
  // const currentQuestion = gameState.active_question || questions[gameState.current_question_index];

const currentQuestion = gameState?.active_question || (questions.length > 0 ? questions[gameState?.current_question_index] : null);

  // --- VIEW 3: ACTIVE GAME & COUNTDOWN STAGES ---
  return (
    <div style={{ background: '#0b0c26', minHeight: '100vh', color: '#fff', padding: '20px', fontFamily: 'Poppins' }}>
      
      {/* 1. SCHEDULED COUNTDOWN STAGE */}
{gameState.game_stage === 'scheduled' && (
        <div className="text-center py-5 mx-auto" style={{ maxWidth: '520px', marginTop: '6%' }}>
          <div style={{ fontSize: '64px', marginBottom: '14px' }}>⏳</div>
          
          <span 
            className="badge px-3 py-2 rounded-pill mb-3" 
            style={{ 
              backgroundColor: 'rgba(99, 222, 204, 0.25)', 
              color: '#63decc', 
              border: '1px solid rgba(99, 222, 204, 0.6)',
              fontSize: '13px',
              fontWeight: '600'
            }}
          >
            Seat Reserved: {playerInfo.name}
          </span>

          <h2 className="fw-bold mb-2" style={{ color: '#ffffff', fontSize: '28px' }}>
            Quiz Scheduled
          </h2>
          
          <p className="small mb-4" style={{ color: '#cbd5e1', fontSize: '14px' }}>
            Room PIN: <strong style={{ color: '#63decc', letterSpacing: '1px' }}>{targetPin}</strong>
          </p>

          <div 
            className="p-4 rounded-4 mb-4" 
            style={{ 
              background: 'rgba(255, 255, 255, 0.1)', 
              border: '1.5px solid rgba(99, 222, 204, 0.4)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)'
            }}
          >
            <p 
              className="text-uppercase mb-2" 
              style={{ 
                color: '#94a3b8', 
                fontSize: '12px', 
                fontWeight: '700', 
                letterSpacing: '1px' 
              }}
            >
              Starts At
            </p>
            <h4 className="fw-bold m-0" style={{ color: '#facc15', fontSize: '22px' }}>
              {gameState?.scheduled_at ? new Date(gameState.scheduled_at).toLocaleString() : 'Scheduled by Host'}
            </h4>
          </div>

          <p style={{ color: '#e2e8f0', fontSize: '13px', lineHeight: '1.6' }}>
            Keep this window open or return at the scheduled time using your PIN and Mobile Number. When the host begins the session, you will connect automatically!
          </p>
        </div>
      )}


      {/* 2. LOBBY STAGE */}
      {gameState.game_stage === 'lobby' && (
        <div className="text-center py-5" style={{ marginTop: '15%' }}>
          <div style={{ fontSize: '64px', marginBottom: '20px' }}>🕹️</div>
          <h2 className="fw-bold">You are linked smoothly!</h2>
          <p style={{ color: "#fff" }} className="fs-5">Room Session Active: <strong style={{ color: '#63decc' }}>{targetPin}</strong></p>
          <p style={{ color: "#fff" }} className="small">Look at the main host display monitor. The match will begin shortly...</p>
        </div>
      )}

      {/* 3. QUESTION STAGE */}
      {/* {gameState.game_stage === 'question' && (
        <div>
          <div className="d-flex justify-content-between align-items-center mb-4 px-2">
            <span className="fw-bold" style={{ color: '#63decc' }}>
              Question {gameState.current_question_index + 1} {gameState.total_questions_count ? `of ${gameState.total_questions_count}` : ''}
            </span>
            <span className="badge bg-warning px-3 py-2 fs-6" style={{ borderRadius: '20px' }}>
              ⏱️ {gameState.seconds_left > 0 ? gameState.seconds_left : 0}s
            </span>
          </div>

          {currentQuestion && !hasAnswered ? (
            <div>
              <div className="bg-white text-dark p-3 rounded-3 text-center mb-4 shadow">
                <h5 className="fw-bold m-0" style={{ fontSize: '16px', lineHeight: '1.4' }}>{currentQuestion.question}</h5>
              </div>

              <div className="row g-3">
                {[currentQuestion.option_1, currentQuestion.option_2, currentQuestion.option_3, currentQuestion.option_4].map((opt, idx) => {
                  if (!opt && idx >= 2) return null; 
                  const optionText = opt || `Choice Option ${idx + 1}`;

                  return (
                    <div key={idx} className="col-6">
                      <button 
                        onClick={() => handleSelectionSubmit(optionText)}
                        className="w-100 border-0 text-white fw-bold shadow-lg d-flex flex-column align-items-center justify-content-center px-2"
                        style={{ background: premiumColors[idx], height: '140px', borderRadius: '16px', position: 'relative' }}
                      >
                        <span style={{ fontSize: '24px', marginBottom: '4px', opacity: 0.8 }}>{shapes[idx]}</span>
                        <span style={{ fontSize: '15px', lineHeight: '1.2' }}>{optionText}</span>
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="text-center py-5 mt-5" style={{ background: 'rgba(255,255,255,0.02)', borderRadius: '24px', border: '1px solid rgba(255,255,255,0.05)' }}>
              <div style={{ fontSize: '56px', marginBottom: '15px' }}>🚀</div>
              <h4 className="fw-bold">Answer Logged Safely</h4>
              <p style={{ color: "#fff" }} className="small px-4">Waiting for the answer confirmation frame update from the host monitor...</p>
            </div>
          )}
        </div>
      )} */}


      {/* 3. QUESTION STAGE */}
      {gameState.game_stage === 'question' && (
        <div>
          <div className="d-flex justify-content-between align-items-center mb-4 px-2">
            <span className="fw-bold" style={{ color: '#63decc' }}>
              Question {gameState.current_question_index + 1} {gameState.total_questions_count ? `of ${gameState.total_questions_count}` : ''}
            </span>
            <span className="badge bg-warning px-3 py-2 fs-6" style={{ borderRadius: '20px' }}>
              ⏱️ {gameState.seconds_left > 0 ? gameState.seconds_left : 0}s
            </span>
          </div>

          {currentQuestion && !hasAnswered ? (
            <div>
              <div className="bg-white text-dark p-3 rounded-3 text-center mb-4 shadow">
                <h5 className="fw-bold m-0" style={{ fontSize: '16px', lineHeight: '1.4' }}>{currentQuestion.question}</h5>
              </div>

              {/* 4 Options Grid with Image and Text Support */}
              <div className="row g-3">
                {[0, 1, 2, 3].map((idx) => {
                  const optText = currentQuestion[`option_${idx + 1}`];
                  const optImg = currentQuestion[`images${idx + 1}`] || currentQuestion[`image_${idx + 1}`];

                  // If neither text nor image exists for option 3 or 4, skip it
                  if (!optText && !optImg && idx >= 2) return null;
                  const optionText = optText || `Option ${idx + 1}`;

                  return (
                    <div key={idx} className="col-6">
                      <button 
                        onClick={() => handleSelectionSubmit(optionText, optImg)}
                        className="w-100 border-0 text-white fw-bold shadow-lg d-flex flex-column align-items-center justify-content-center px-2 py-2"
                        style={{ 
                          background: premiumColors[idx], 
                          minHeight: optImg ? '150px' : '130px', 
                          borderRadius: '16px', 
                          position: 'relative' 
                        }}
                      >
                        <span style={{ fontSize: '18px', marginBottom: '2px', opacity: 0.85 }}>{shapes[idx]}</span>
                        
                        {/* 👉 RENDER IMAGE FOR IMAGE QUIZ */}
                        {optImg && (
                          <div className="my-1 w-100 text-center">
                            <img 
                              src={optImg} 
                              alt={`Option ${idx + 1}`} 
                              style={{ 
                                maxHeight: '80px', 
                                maxWidth: '90%', 
                                borderRadius: '8px', 
                                objectFit: 'contain',
                                background: 'rgba(255,255,255,0.2)',
                                padding: '3px'
                              }} 
                            />
                          </div>
                        )}

                        {optText && (
                          <span style={{ fontSize: '13px', lineHeight: '1.2' }}>
                            {optText}
                          </span>
                        )}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="text-center py-5 mt-5" style={{ background: 'rgba(255,255,255,0.02)', borderRadius: '24px', border: '1px solid rgba(255,255,255,0.05)' }}>
              <div style={{ fontSize: '56px', marginBottom: '15px' }}>🚀</div>
              <h4 className="fw-bold">Answer Logged Safely</h4>
              <p style={{ color: "#fff" }} className="small px-4">Waiting for the answer confirmation frame update from the host monitor...</p>
            </div>
          )}
        </div>
      )}

      {/* 4. REVEAL STAGE */}
      {gameState.game_stage === 'reveal' && (
        <div className="text-center py-5 mt-5" style={{ borderRadius: '24px', background: isCorrectSelection ? 'rgba(38, 137, 12, 0.12)' : 'rgba(226, 27, 60, 0.12)', border: `1px solid ${isCorrectSelection ? '#26890c' : '#e21b3c'}` }}>
          <div style={{ fontSize: '72px' }}>{isCorrectSelection ? '✅' : '❌'}</div>
          <h2 className="fw-bold mt-2" style={{ color: isCorrectSelection ? '#26890c' : '#e21b3c' }}>{isCorrectSelection ? 'Correct' : 'Incorrect'}</h2>
          <h1 className="fw-extrabold mt-3" style={{ fontSize: '48px', color: '#63decc' }}>+{scoreFeedback} pts</h1>
        </div>
      )}

      {/* 5. PODIUM STAGE */}
      {gameState.game_stage === 'podium' && (
        <div className="text-center py-4 animate-fade-in" style={{ marginTop: '5%', minHeight: '80vh' }}>
          <div className="mb-4">
            <div style={{ fontSize: '72px', animation: 'pulse 2s infinite' }}>🏁</div>
            <h2 className="fw-bold mt-2 text-white" style={{ letterSpacing: '-0.5px' }}>Quiz Completed!</h2>
            <p className="small" style={{ color: '#a0aec0' }}>Let's see how well you performed across all rounds</p>
          </div>

          {!personalStats ? (
            <div className="p-4 rounded-4" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.05)', color: '#a0aec0' }}>
              <div className="spinner-border spinner-border-sm text-info mb-2" role="status"></div>
              <p className="small m-0">Compiling your match records...</p>
            </div>
          ) : (
            <div className="mx-auto" style={{ maxWidth: '400px' }}>
              <div className="p-4 mb-3 rounded-4 shadow-lg text-center" style={{ 
                background: 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.01) 100%)', 
                border: '1px solid rgba(99,222,204,0.3)',
                boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
              }}>
                <span className="text-uppercase small tracking-wide fw-bold d-block mb-1" style={{ color: '#a0aec0', letterSpacing: '1px' }}>Your Final Placement</span>
                <h1 className="fw-extrabold m-0" style={{ fontSize: '56px', color: '#63decc' }}>
                  {personalStats.player_rank <= 3 ? '🏅' : '👤'} #{personalStats.player_rank}
                </h1>
                <span className="badge mt-2 px-3 py-1.5 bg-dark text-white rounded-pill small" style={{ border: '1px solid rgba(255,255,255,0.1)' }}>
                  Out of all arena players
                </span>
              </div>

              <div className="row g-2 mb-4">
                <div className="col-12">
                  <div className="p-3 rounded-3 text-start d-flex justify-content-between align-items-center" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}>
                    <span className="fw-semibold text-white">✨ Cumulative Score:</span>
                    <strong className="fs-4 text-warning">
                      {personalStats.total_score} <span className="small fw-normal" style={{ fontSize: '12px', color: '#a0aec0' }}>pts</span>
                    </strong>
                  </div>
                </div>
                <div className="col-6">
                  <div className="p-3 rounded-3 text-center" style={{ background: 'rgba(38, 137, 12, 0.12)', border: '1px solid rgba(38, 137, 12, 0.3)' }}>
                    <span className="d-block small fw-bold text-uppercase mb-1" style={{ color: '#81e6d9', letterSpacing: '0.5px' }}>Correct</span>
                    <h3 className="fw-bold m-0 text-success">✅ {personalStats.correct_count}</h3>
                  </div>
                </div>
                <div className="col-6">
                  <div className="p-3 rounded-3 text-center" style={{ background: 'rgba(226, 27, 60, 0.12)', border: '1px solid rgba(226, 27, 60, 0.3)' }}>
                    <span className="d-block small fw-bold text-uppercase mb-1" style={{ color: '#feb2b2', letterSpacing: '0.5px' }}>Incorrect</span>
                    <h3 className="fw-bold m-0 text-success" style={{ color: '#ff4d6d' }}>❌ {personalStats.wrong_count}</h3>
                  </div>
                </div>
              </div>

              <div className="p-3 rounded-3 text-center" style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(255,255,255,0.05)' }}>
                <p className="m-0 small" style={{ color: '#cbd5e0', lineHeight: '1.5' }}>
                  Look up at the main host display monitor to see the full leaderboard podium ceremony!
                </p>
              </div>
            </div>
          )}
        </div>
      )}

      {/* 6. ABANDONED STAGE */}
      {gameState.game_stage === 'abandoned' && (
        <div className="text-center py-5 mx-auto" style={{ maxWidth: '480px', marginTop: '12%' }}>
          <div style={{ fontSize: '56px', marginBottom: '14px' }}>⚠️</div>
          <h3 className="fw-bold text-danger mb-2">Session Terminated</h3>
          <p className="small mb-4">The host has closed or disconnected from this game room.</p>
          <button 
            onClick={() => {
              localStorage.removeItem(`quiz_session_${targetPin}`);
              window.location.reload();
            }} 
            className="btn btn-outline-light px-4 py-2"
            style={{ borderRadius: '10px' }}
          >
            Back to Home
          </button>
        </div>
      )}

    </div>
  );
};

export default ParticipantArena;




